import Image from 'assets/images/login-top.png';
import { shadowColor, themePink } from 'theme/color';
import { poppins300, poppins700 } from 'theme/common.style';

export const signUpFormCont = {
  backgroundImage: `url(${Image})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '350px 170px',
  paddingLeft: '6em !important',
  paddingTop: '15em !important',
  overflow: 'auto',
};

export const TextFieldError = {
  '.MuiFormHelperText-contained': {
    margin: '0',
    fontFamily: 'Poppins !important',
  },
  '& input[type=number]': {
    '-moz-appearance': 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  width: '100%',
  '& input::placeholder': {
    textTransform: 'none !important',
  },
};
export const labelText = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '300',
  fontSize: '18px !important',
  color: 'black !important',
  fontWeight: '500 !important',
  paddingBottom: '5px',
};

export const signUpText = {
  ...poppins300,
  paddingTop: '0.2em',
  paddingBottom: '0.5em',
};

export const signUpHeader = {
  ...poppins700,
  color: themePink,
};

export const registerBtn = {
  color: '#000000',
  width: '120px',
  alignSelf: 'flex-end',
  marginTop: '50px',
  textTransform: 'none',
  padding: '10px 20px',
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: 400,
  fontSize: '16px !important',
};

export const tabs = {
  height: '32%',
  width: '20%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: `0px 1px 8px ${shadowColor}`,
  borderRadius: '10px',
  fontSize: '24px',
  fontFamily: 'poppins',
  fontWeight: 400,
  cursor: 'pointer',
  '&:hover': {
    border: '2px solid rgba(119, 207, 254, 1)',
  },
};
